import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ac59ea0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-accounting-details" }
const _hoisted_2 = { class: "accounting-details" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "__left" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Accounting"),
    /*#__PURE__*/_createElementVNode("h2", null, "Accounting details")
  ])
], -1))
const _hoisted_4 = { class: "ls-table" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["colspan"]
const _hoisted_7 = ["colspan"]
const _hoisted_8 = { "data-label": "Trust account INV ID" }
const _hoisted_9 = { "data-label": "Investigation date" }
const _hoisted_10 = {
  key: 0,
  "data-label": "Year"
}
const _hoisted_11 = {
  "data-label": "Trust account",
  class: "currency"
}
const _hoisted_12 = {
  key: 1,
  "data-label": "Year"
}
const _hoisted_13 = {
  key: 2,
  "data-label": "AC"
}
const _hoisted_14 = {
  "data-label": "Controlled",
  class: "currency"
}
const _hoisted_15 = {
  key: 3,
  "data-label": "Year"
}
const _hoisted_16 = {
  key: 4,
  "data-label": "AC"
}
const _hoisted_17 = {
  "data-label": "Powered",
  class: "currency"
}
const _hoisted_18 = {
  key: 5,
  "data-label": "Year"
}
const _hoisted_19 = {
  key: 6,
  "data-label": "AC"
}

export function render(_ctx, _cache) {
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", {
                class: _normalizeClass(h.cellClass)
              }, [
                _createElementVNode("p", null, _toDisplayString(h.text), 1)
              ], 2))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (!_ctx.loadingContent && _ctx.accountingDetails.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                (!_ctx.errorLoadingContent)
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 0,
                      colspan: _ctx.tableHeadings.length
                    }, "No Records", 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("td", {
                      key: 1,
                      colspan: _ctx.tableHeadings.length
                    }, [
                      _createVNode(_component_ErrorIndicator)
                    ], 8, _hoisted_7))
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.accountingDetails, (aD) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(aD.id), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$formatDate(aD.commencementDate)), 1),
                  (!_ctx.fullWidth)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(_ctx.$formatMMYYYY(aD.trustMonthYear)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.formatNumberToCurrencyWithZero(aD.trustAmount)), 1),
                  (_ctx.fullWidth)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_ctx.$formatMMYYYY(aD.trustMonthYear)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.fullWidth)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(aD.trustAccountNumber), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.formatNumberToCurrencyWithZero(aD.controlMoneyAmount)), 1),
                  (_ctx.fullWidth)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(_ctx.$formatMMYYYY(aD.controlMoneyMonthYear)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.fullWidth)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(aD.controlMoneyAccountNumber), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatNumberToCurrencyWithZero(aD.powerMoneyAmount)), 1),
                  (_ctx.fullWidth)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(_ctx.$formatMMYYYY(aD.powerMoneyMonthYear)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.fullWidth)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(aD.powerMoneyAccountNumber), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 256))
        ])
      ])
    ])
  ]))
}